import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import trackSectionListShown from '@conversion/tracking/actions/trackSectionListShown';
import fetchSectionsList from '@shopDetails/actions/fetchSectionsList';
import getIsFetchingSectionList from '@shopDetails/selectors/getIsFetchingSectionList';

import SectionsList from './SectionsList';

const mapStateToProps = createStructuredSelector({
  isFetching: getIsFetchingSectionList,
});

const mapDispatchToProps = {
  fetchSectionsList,
  trackSectionListShown,
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionsList);
